import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

const AboutUs: React.FC = () => {
  const sectionHeading: React.CSSProperties = {
    fontSize: '22px',
    fontWeight: 600,
    color: '#1e1b4b',
    marginTop: '40px',
    marginBottom: '16px',
    paddingBottom: '12px',
    borderBottom: '2px solid #e5e7eb'
  };

  const sectionHeadingFirst: React.CSSProperties = {
    ...sectionHeading,
    marginTop: 0
  };

  const paragraph: React.CSSProperties = {
    fontSize: '15px',
    lineHeight: '1.7',
    color: '#374151',
    marginBottom: '12px'
  };

  const tableStyle: React.CSSProperties = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '16px',
    marginBottom: '8px',
    fontSize: '14px'
  };

  const thStyle: React.CSSProperties = {
    background: '#f9fafb',
    color: '#1e1b4b',
    fontWeight: 600,
    textAlign: 'left',
    padding: '12px 16px',
    borderBottom: '2px solid #e5e7eb'
  };

  const tdStyle: React.CSSProperties = {
    padding: '12px 16px',
    borderBottom: '1px solid #f3f4f6',
    color: '#374151'
  };

  const listStyle: React.CSSProperties = {
    fontSize: '15px',
    lineHeight: '1.9',
    color: '#374151',
    paddingLeft: '20px',
    marginBottom: '16px'
  };

  return (
    <div className="layout-wrapper landing">
      <SeoHead
        title="About CodeRom — Built by Sellers"
        description="CodeRom is an AI-powered Amazon to eBay automation platform built by sellers, for sellers."
      />
      <Navbar />

      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '120px 20px 60px'
      }}>
        {/* Breadcrumb */}
        <div style={{ marginBottom: '24px', fontSize: '14px' }}>
          <Link to="/" style={{ color: '#6366f1', textDecoration: 'none' }}>Home</Link>
          <span style={{ margin: '0 8px', color: '#9ca3af' }}>›</span>
          <span style={{ color: '#6b7280' }}>About</span>
        </div>

        {/* Başlık kartı */}
        <div style={{
          background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
          borderRadius: '16px',
          padding: '40px',
          marginBottom: '32px',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '32px', fontWeight: 700, margin: '0 0 8px' }}>About Coderom</h1>
          <p style={{ fontSize: '14px', opacity: 0.8, margin: 0 }}>Built by sellers, for sellers</p>
        </div>

        {/* Ana içerik kartı */}
        <div style={{
          background: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '40px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>

          {/* Section 1 — Our Story */}
          <div>
            <h2 style={sectionHeadingFirst}>1. Our Story</h2>
            <p style={paragraph}>
              Coderom was born from a simple frustration: managing an eBay dropshipping business manually
              is exhausting. Updating prices, monitoring stock, processing orders — it takes hours every
              day that could be spent growing your business.
            </p>
            <p style={paragraph}>
              We built Coderom to automate the repetitive work so you can focus on what matters: finding
              great products and scaling your sales.
            </p>
          </div>

          {/* Section 2 — What We Do */}
          <div>
            <h2 style={sectionHeading}>2. What We Do</h2>
            <p style={paragraph}>
              Coderom is an AI-powered e-commerce automation platform that connects Amazon and eBay.
              We help sellers:
            </p>
            <ul style={listStyle}>
              <li>Automatically sync prices between Amazon and eBay</li>
              <li>Monitor stock levels and prevent overselling</li>
              <li>Create optimised listings with AI-generated titles and descriptions</li>
              <li>Process orders with automatic ordering technology</li>
              <li>Track shipments with Gmail integration</li>
              <li>Manage multiple eBay stores from one dashboard</li>
            </ul>
          </div>

          {/* Section 3 — Our Technology */}
          <div>
            <h2 style={sectionHeading}>3. Our Technology</h2>
            <p style={paragraph}>
              Built with modern technology and designed for reliability:
            </p>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Feature</th>
                  <th style={thStyle}>Technology</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tdStyle}>AI Listings</td>
                  <td style={tdStyle}>GPT-4o powered title and description generation</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Price Monitoring</td>
                  <td style={tdStyle}>Real-time Amazon price tracking across 6 marketplaces</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Stock Sync</td>
                  <td style={tdStyle}>Automated inventory synchronisation every few hours</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Order Automation</td>
                  <td style={tdStyle}>Chrome extension-based automatic ordering</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Tracking</td>
                  <td style={tdStyle}>Gmail integration for automatic tracking upload</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Dashboard</td>
                  <td style={tdStyle}>Real-time analytics and daily reports</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 4 — Supported Marketplaces */}
          <div>
            <h2 style={sectionHeading}>4. Supported Marketplaces</h2>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Marketplace</th>
                  <th style={thStyle}>Amazon Source</th>
                  <th style={thStyle}>eBay Destination</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={tdStyle}>United Kingdom</td>
                  <td style={tdStyle}>amazon.co.uk</td>
                  <td style={tdStyle}>ebay.co.uk</td>
                </tr>
                <tr>
                  <td style={tdStyle}>United States</td>
                  <td style={tdStyle}>amazon.com</td>
                  <td style={tdStyle}>ebay.com</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Germany</td>
                  <td style={tdStyle}>amazon.de</td>
                  <td style={tdStyle}>ebay.de</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Canada</td>
                  <td style={tdStyle}>amazon.ca</td>
                  <td style={tdStyle}>ebay.ca</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Australia</td>
                  <td style={tdStyle}>amazon.com.au</td>
                  <td style={tdStyle}>ebay.com.au</td>
                </tr>
                <tr>
                  <td style={tdStyle}>Spain</td>
                  <td style={tdStyle}>amazon.es</td>
                  <td style={tdStyle}>ebay.es</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 5 — The Company */}
          <div>
            <h2 style={sectionHeading}>5. The Company</h2>
            <p style={paragraph}>
              Coderom is operated by <strong>Enerfix Limited</strong>, registered in England and Wales.
              We are based in the United Kingdom and serve sellers worldwide.
            </p>
            <div style={{
              background: '#eff6ff',
              borderLeft: '4px solid #3b82f6',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#1e40af', fontSize: '14px', margin: 0 }}>
                <strong>Company details:</strong><br />
                Enerfix Limited<br />
                Registered in England and Wales<br />
                Email: support@coderom.com
              </p>
            </div>
          </div>

          {/* Section 6 — Get in Touch */}
          <div>
            <h2 style={sectionHeading}>6. Get in Touch</h2>
            <ul style={listStyle}>
              <li>Email: <a href="mailto:support@coderom.com" style={{ color: '#6366f1' }}>support@coderom.com</a></li>
              <li>Help Center: <Link to="/help" style={{ color: '#6366f1' }}>/help</Link></li>
              <li>Blog: <Link to="/blog" style={{ color: '#6366f1' }}>/blog</Link></li>
            </ul>
          </div>

          {/* CTA card */}
          <div style={{
            marginTop: '40px',
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            borderRadius: '16px',
            padding: '32px',
            textAlign: 'center',
            color: 'white'
          }}>
            <h3 style={{ fontSize: '22px', fontWeight: 700, margin: '0 0 12px' }}>
              Ready to automate your eBay business?
            </h3>
            <p style={{ fontSize: '15px', opacity: 0.9, margin: '0 0 20px' }}>
              Join sellers who save hours every day with Coderom.
            </p>
            <Link
              to="/register"
              style={{
                display: 'inline-block',
                background: 'white',
                color: '#6366f1',
                padding: '12px 28px',
                borderRadius: '10px',
                fontWeight: 600,
                fontSize: '15px',
                textDecoration: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
              }}
            >
              Start Free →
            </Link>
          </div>

        </div>
      </div>

      <Footer />
      <GuestChatWidget />
    </div>
  );
};

export default AboutUs;
